import { CURRENCY_SYMBOLS } from './constants';
import { type CurrencyType } from './types';

export function formatCurrency(
  value: number,
  currency: CurrencyType,
  forceMillions = false,
): string {
  if (Number.isNaN(value) || !Number.isFinite(value)) return '—';
  const symbol = CURRENCY_SYMBOLS[currency];
  const absValue = Math.abs(value);

  if (forceMillions && absValue < 1_000_000) {
    return `${symbol}${formatNumber(Math.round(absValue))}`;
  }

  if (absValue >= 1_000_000) {
    const millions = absValue / 1_000_000;
    const formatted = millions >= 100 ? millions.toFixed(0) : millions.toFixed(2);
    return `${symbol}${formatted}M`;
  }

  if (absValue >= 1_000) {
    return `${symbol}${formatNumber(Math.round(absValue))}`;
  }

  return `${symbol}${Math.round(absValue)}`;
}

export function formatNumber(value: number): string {
  return value.toLocaleString('en-GB');
}

export function getCurrencySymbol(currency: CurrencyType): string {
  return CURRENCY_SYMBOLS[currency];
}
